import React from 'react';
import { Col, Row } from 'antd';
import styles from './styles.module.scss';

const CertificationReportHeader: React.FC = (): JSX.Element => {
  return (
    <Row className={styles.row}>
      <Col span={6}>
        <div style={{ marginTop: '22px', marginLeft: '15px' }}>
          <p className={styles['col-name']}>
            <b>Name</b>
          </p>
        </div>
      </Col>
      <Col span={5}>
        <div style={{ marginTop: '22px' }}>
          <p className={styles['col-name']}>
            <b>Designation</b>
          </p>
        </div>
      </Col>
      <Col span={3}>
        <div style={{ marginTop: '22px' }}>
          <p className={styles['col-name']}>
            <b>Count</b>
          </p>
        </div>
      </Col>
      <Col span={10}>
        <div style={{ marginTop: '22px' }}>
          <p className={styles['col-name']}>
            <b>Certifications</b>
          </p>
        </div>
      </Col>
    </Row>
  );
};

export default CertificationReportHeader;
